import React from "react"
import { css } from "styled-components"
import { Block, Spacer } from "../atoms/layout-primitives"
import Text from "../atoms/text"
import VariantContainer from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"

interface INavBlockProps {
  icon: React.ReactNode
  title: string
  children: any
}

/**
 * A block with icon, title, and links
 * @param icon - icon to display
 * @param title - title to display
 * @param children - links to display
 */
const NavBlock = ({ icon, title, children: links }: INavBlockProps) => {
  return (
    <VariantContainer
      variants={[
        css`
          display: flex;
          flex-direction: column;
          padding: 32px 16px;
          background-color: var(--white);
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          text-align: center;
          box-sizing: border-box;
          overflow: hidden;
          width: 100%;
        `,
      ]}
    >
      <Block>
        <Text
          as="h3"
          variants={[
            css`
              ${BT.sm.h3`500`};
              display: inline;
              padding-right: 16px;
              color: var(--burnt-orange);
            `,
          ]}
        >
          {icon}
        </Text>
        <Text
          as="h3"
          variants={[
            css`
              ${BT.sm.h3`500`};
              display: inline;
            `,
          ]}
        >
          {title}
        </Text>
      </Block>
      <Spacer height={{ sm: "16px" }} />
      <VariantContainer
        variants={[
          css`
            display: flex;
            flex-direction: row;
            gap: 20px;
            justify-content: center;
            a {
              text-decoration: none;
              ${BT.sm.body`400`};
              font-size: 16px;
            }
          `,
        ]}
      >
        {links}
      </VariantContainer>
    </VariantContainer>
  )
}

export default NavBlock
